export * from './view-page.component';